import "./spiner.scss";

export default function Spinner({pointerEvents = "none", withBackgroundColor = false, size = 80}) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        pointerEvents,
        backgroundColor: withBackgroundColor ? "rgb(133 129 129 / 30%)" : "unset",
      }}
    >
      <div className="dual-spinner" style={{width: size, height: size}} role="status" aria-label="Loading" />
    </div>
  );
}
